export const getAccountCodeFromStorage = () => {
  return window.sessionStorage.getItem('accountCode')
}

export const getAccountNameFromStorage = () => {
  return window.sessionStorage.getItem('accountName')
}

export const getPersonCodeFromStorage = () => {
  return window.sessionStorage.getItem('accountPersonCode')
}

export const getPersonNameFromStorage = () => {
  return window.sessionStorage.getItem('accountPersonName')
}

export const getYqCodeFromStorage = () => {
  return window.sessionStorage.getItem('yqCode')
}

export const getYqNameFromStorage = () => {
  return window.sessionStorage.getItem('yqName')
}

export const getTokenImmediately = () => {
  return window.sessionStorage.getItem('token')
}

export const setTokenImmediately = (token) => {
  return window.sessionStorage.setItem('token', token)
}

export const getAccountIdImmediately = () => {
  return window.sessionStorage.getItem('accountId')
}

export const getPermissionCodesFromStorage = () => {
  return window.sessionStorage.getItem('permissionCodes')
}

export const getUpperDataFromStorage = () => {
  let yqAppCodeListStr = window.sessionStorage.getItem('upperYqAppCodeList')
  let yqAppCodeList = []
  if (yqAppCodeListStr) {
    yqAppCodeList = JSON.parse(yqAppCodeListStr)
  }
  let upperData = {
    accountName: window.sessionStorage.getItem('upperAccountName') || '',
    accountCode: window.sessionStorage.getItem('upperAccountCode') || '',
    token: window.sessionStorage.getItem('upperToken') || '',
    yqAppCodeList: yqAppCodeList,
    groupAppCode: window.sessionStorage.getItem('groupAppCode') || '',
  }
  return upperData
}

export const getPermissionImmediately = () => {
  return [
    window.sessionStorage.getItem('arrF'),
    window.sessionStorage.getItem('arrS'),
    window.sessionStorage.getItem('arrT'),
    window.sessionStorage.getItem('arrE'),
  ]
}



// WEBPACK FOOTER //
// ./src/utils/storage.js